import { Avatar, Box, Button, Grid, Grid2, IconButton, InputAdornment, MenuItem, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import config from '../../config/config.js';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import { Label } from "flowbite-react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CloseIcon from '@mui/icons-material/Close';
import { makeGetRequestToUrl } from "../commonFunc.jsx";
import dayjs, { utc } from 'dayjs';
import blueCar from '../../assets/icons/blueCar.svg';
import PersonIcon from '@mui/icons-material/Person';
import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo/DemoContainer.js";
import { makePostRequestToUrl } from "../commonFunc.jsx";

dayjs.extend(utc);

const FuelConsumption = () => {
    const date_format_dd_mm_yy = localStorage.getItem('date_format_dd_mm_yy');
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [tokenExpired, setTokenExpired] = useState(false);
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('helper_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [open, setOpen] = useState(false);
    const [editable, setEditable] = useState(false);
    const [vehiclesData, setVehiclesData] = useState([]);
    const [driverName, setDriverName] = useState('');
    const [fuelAmount, setFuelAmount] = useState('');
    const [extraCharge, setExtraCharge] = useState('');
    const [vehicleId, setVehicleId] = useState('');
    const [fuelingDateTime, setFuelingDateTime] = useState(dayjs());
    const [errorMessage, setErrorMessage] = useState('');
    const [driversData, setDriversData] = useState([]);
    const [driverPhoneFilter, setDriverPhoneFilter] = useState('');
    const [filteredPhoneNumbers, setFilteredPhoneNumbers] = useState([]);
    const [showPhoneResults, setShowPhoneResults] = useState(false);
    const [driverId, setDriverID] = useState('');
    const [driverPhone, setDriverPhone] = useState('');
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [fuelType, setFuelType] = useState('0');
    const [fuelId, setFuelId] = useState('');
    const [driverIdFilter, setDriverIdFilter] = useState('');
    const [fuelTypeFilter, setFuelTypeFilter] = useState('');
    const [allRows, setAllRows] = useState([]);
    const [carWashAmount, setCarWashAmount] = useState('');
    const [carParkingAmount, setCarParkingAmount] = useState('');
    const [startDateFilter, setStartDateFilter] = useState(dayjs().startOf('month').startOf('day'));
    const [endDateFilter, setEndDateFilter] = useState(dayjs().endOf('month').startOf('day'));

    const utcOffset = parseInt(localStorage.getItem('utc_offset') || '330', 10);
    const timeZoneFormat = localStorage.getItem('time_zone_format') || '12';

    const handleCityChange = (e) => {
        const city = cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const FuelTypeOptions = [
        { value: '', label: 'All' },
        { value: '1', label: 'Petrol' },
        { value: '2', label: 'Diesel' },
    ];
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleClose = () => {
        setOpen(false);
        setEditable(false);
    }

    const fetchVehicleData = async () => {
        try {
            const url = serverUrl + '/vehicle/fetch_vehicle_make';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if (response.flag == 200) {
                setVehiclesData(response.data);
            }
            if (response.flag == 102) {
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchDriversData = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            const url = `${serverUrl}/driver/fetch_all`;
            const obj = {
                token: token, timestamp: timestamp
            }
            if (cityFilter) obj['city_id'] = cityFilter;

            const response = await makeGetRequestToUrl(url, obj);

            if (response.flag == 102) {
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if (response.flag === 200) {
                const driversData = response.data;
                setDriversData(driversData);
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setDriversData([]);
        }
    };

    const fetchFuelConsumptionData = async () => {
        try {
            const url = serverUrl + '/driver/fetch_driver_fuel_consumption';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                start_date: startDateFilter.format('YYYY-MM-DD'),
                end_date: endDateFilter.format('YYYY-MM-DD'),
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if (response.flag == 200) {
                setRows(response.data);
                setAllRows(response.data); // Store all rows for filtering
            }
            if (response.flag == 102) {
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        fetchVehicleData();
        fetchDriversData();
    }, [cityFilter]);

    useEffect(() => {
        fetchFuelConsumptionData();
    }, [startDateFilter, endDateFilter, cityFilter]);

    const handleOpenAddModal = () => {
        setOpen(true);
        setEditable(false);
        setDriverID('');
        setDriverPhone('');
        setDriverName('');
        setFuelAmount('');
        setExtraCharge('');
        setVehicleId('');
        setFuelId('');
        setCarWashAmount('');
        setCarParkingAmount('');
        setFuelType('0');
        setFuelingDateTime(dayjs());
    }

    const handleOpenEditModal = (row) => {
        setOpen(true);
        setEditable(true);
        setDriverID(row.driver_id);
        setDriverPhone(row.phone_number);
        setDriverName(row.driver_name);
        setFuelAmount(row.amount);
        setExtraCharge(row.extra_charge);
        setVehicleId(row.vehicle_id);
        setFuelingDateTime(dayjs(row.date));
        setFuelType(row.fuel_type);
        setFuelId(row.id);
        setCarWashAmount(row.car_wash_amount);
        setCarParkingAmount(row.car_parking_amount);
    }

    const handleFuelTypeChange = (event) => {
        setFuelTypeFilter(event.target.value);
    };

    const handleDriverIdFilterChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
        setDriverIdFilter(value);
    }
};

    // 2. The main filter function
    const applyFilters = () => {
        let filtered = allRows;

        if (fuelTypeFilter) {
            filtered = filtered.filter(row => String(row.fuel_type) === String(fuelTypeFilter));
        }
        if (driverIdFilter) {
            filtered = filtered.filter(row => String(row.driver_id).includes(driverIdFilter));
        }

        setRows(filtered);
    };

    useEffect(() => {
        applyFilters();
    }, [fuelTypeFilter, driverIdFilter, allRows]);

    const handleReset = () => {
        setFuelTypeFilter('');
        setDriverIdFilter('');
    }

    const handleSubmit = async () => {
        const token = localStorage.getItem('token');
        if(!driverId){
            setMessage('Please select a driver.')
            showSnackbar(true);
            return;
        }
        if(!vehicleId){
            setMessage('Please select a vehicle.')
            showSnackbar(true);
            return;
        }
        if(!fuelAmount && !extraCharge && !carParkingAmount && !carWashAmount){
            setMessage('Please fill atleast one amount.')
            showSnackbar(true);
            return;
        }

        if(!fuelAmount && fuelType!=0){
            setMessage('Please fill fuel amount.')
            showSnackbar(true);
            return;
        }

        if(fuelType==0 && fuelAmount){
            setMessage('Please select fuel type.')
            showSnackbar(true);
            return;
        }
        const payload = {
            token: token,
            driver_id: driverId,
            vehicle_id: vehicleId,
            date: fuelingDateTime ? dayjs(fuelingDateTime).format('YYYY-MM-DD HH:mm:ss') : null,
            fuel_type: fuelType,
            // fueling_date_time: fuelingDateTime.format("YYYY-MM-DD HH:mm:ss"),
        };
        if(!fuelAmount){
            payload.amount = 0;
        }else {
            payload.amount = fuelAmount;
        }

        if(!extraCharge){
            payload.extra_charge = 0;
        }else {
            payload.extra_charge = extraCharge;
        }

        if(!carParkingAmount){
            payload.car_parking_amount = 0;
        }else {
            payload.car_parking_amount = carParkingAmount;
        }

        if(!carWashAmount){
            payload.car_wash_amount = 0;
        }else {
            payload.car_wash_amount = carWashAmount;
        }
        if (fuelId != '') {
            payload['id'] = fuelId
        }
        try {
            const url = operationsUrl + '/driver/add_update_driver_fuel_consumption';
            const response = await makePostRequestToUrl(url, payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true); handleClose(); // Close the modal after saving
                fetchFuelConsumptionData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            setMessage(error);
        }
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    return (
        <div>
            {tokenExpired && (<TokenError />)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Fuel Consumption
            </Typography>

            <Grid2 container spacing={2} alignItems="flex-end" style={{ marginTop: '2%', marginBottom: '3%' }}>
                {/* <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2> */}
                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddModal}
                        style={{
                            width: '120px',
                            height: '45px',
                            backgroundColor: '#0065ff',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        + Add
                    </Button>
                </Grid2>

                <Grid2 item sx={{ marginLeft: '1%' }}>
                    <Label>Fuel Type:</Label><br />
                    <Select
                        value={fuelTypeFilter}
                        onChange={handleFuelTypeChange} displayEmpty
                        style={{ width: '185px', height: '45px', marginTop: '4px', borderRadius: '8px',backgroundColor: '#FFFFFF' }}>
                        {FuelTypeOptions?.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                <Grid2 item sx={{ marginLeft: '1%' }}>
                    <Label>Driver Id:</Label><br />
                    <TextField
                        size="small"
                        placeholder="Enter Driver Id"
                        value={driverIdFilter}
                        onChange={(e) => handleDriverIdFilterChange(e)}
                        sx={{
                            width: '190px',
                            '& .MuiInputBase-root': {
                                height: '45px',
                                borderRadius: '8px',
                                backgroundColor: '#FFFFFF',
                                marginTop: '4px'
                            }
                        }}
                    />
                </Grid2>

                <Grid2 item>
                    <Label>Start Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px'
                                }
                            }}
                            value={startDateFilter}
                            format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                            onChange={(newValue) => {
                                if (endDateFilter && newValue && newValue.isAfter(endDateFilter)) {
                                    setEndDateFilter(null);
                                }
                                setStartDateFilter(newValue);
                            }}
                            maxDate={endDateFilter || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item>
                    <Label>End Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px'
                                }
                            }}
                            value={endDateFilter}
                            onChange={(newValue) => {
                                setEndDateFilter(newValue)
                            }}
                            minDate={startDateFilter || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>
                
                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleReset}
                        style={{
                            width: '120px',
                            height: '45px',
                            backgroundColor: '#0065ff',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        Reset
                    </Button>
                </Grid2>
                {/* <Grid2 item sx={{ marginLeft: "auto", display: 'flex', alignItems: 'center', gap: 2 }}>
                    <input
                        type="file"
                        accept=".csv"
                        ref={fileInputRef}
                        onChange={handleImportCSV}
                        style={{ display: 'none' }}
                    />
                    <Button
                        variant="outlined"
                        onClick={() => downloadCSVTemplate()}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '48px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <img src={importArrowIcon} alt="Import CSV" style={{ width: 20, height: 20, marginRight: 8, marginTop: 2 }} />
                        <span style={{ fontWeight: 500, fontSize: 16 }}>Sample CSV</span>
                    </Button>

                    <Button
                        variant="outlined"
                        onClick={() => fileInputRef.current.click()}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '48px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <img src={importArrowIcon} alt="Import CSV" style={{ width: 20, height: 20, marginRight: 8, marginTop: 2 }} />
                        <span style={{ fontWeight: 500, fontSize: 16 }}>Import CSV</span>
                    </Button>

                    <Button
                        variant="outlined"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '48px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <CSVLink
                            data={allData}
                            headers={headers}
                            filename={"Helpers Data.csv"}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                textDecoration: 'none',
                                color: 'inherit',
                                width: '100%',
                                justifyContent: 'center',
                            }}
                        >
                            <span style={{ fontWeight: 500, fontSize: 16 }}>Export CSV</span>
                            <img src={exportCSVIcon} alt="Export CSV" style={{ width: 18, height: 18, marginLeft: 4, marginTop: 2 }} />
                        </CSVLink>
                    </Button>
                </Grid2> */}
            </Grid2>


            {open && (
                <div
                    style={{
                        position: 'fixed', top: 65, right: 0, height: '100%', width: '50%', backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', transition: 'right 0.3s ease-in-out',
                        zIndex: 1000, overflowY: 'auto', padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute', top: '-15px', left: '1px', color: '#333', zIndex: 10
                                }}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{
                                    padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'
                                }}>
                                <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                    {editable ? 'Edit' : 'Add'}
                                </Typography>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        {/* <Label style={{color:'#1A1E25', fontSize:'16px'}}>Driver Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'1%'}} placeholder="Driver Name" fullWidth variant="outlined" type="text"
                                            value={driverName} 
                                            onChange={(e) => {
                                                setDriverName(e.target.value);
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius:'12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        /> */}
                                        <Grid2 item>
                                            <Box sx={{
                                                position: 'relative',
                                                width: '100%',
                                                mt: 1,
                                                mb: 2
                                            }}>
                                                <TextField
                                                    placeholder="Search by Phone Number"
                                                    fullWidth
                                                    variant="outlined"
                                                    value={driverPhoneFilter}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setDriverPhoneFilter(value);

                                                        // Filter customers based on phone number
                                                        if (value && value.length > 2) {
                                                            const filtered = driversData.filter(driver =>
                                                                driver.phone_number &&
                                                                driver.phone_number.includes(value)
                                                            );
                                                            setFilteredPhoneNumbers(filtered);
                                                            setShowPhoneResults(filtered.length > 0);
                                                        } else {
                                                            setFilteredPhoneNumbers([]);
                                                            setShowPhoneResults(false);
                                                        }
                                                    }}
                                                    onBlur={() => {
                                                        setTimeout(() => setShowPhoneResults(false), 200);
                                                    }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <Box sx={{ mr: 1 }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                    <circle cx="11" cy="11" r="8"></circle>
                                                                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                                                </svg>
                                                            </Box>
                                                        ),
                                                        style: { height: '52px', borderRadius: '12px', fontSize: '16px', backgroundColor: '#f9f9f9' }
                                                    }}
                                                />
                                                {showPhoneResults && filteredPhoneNumbers.length > 0 && (
                                                    <Box sx={{
                                                        position: 'absolute',
                                                        width: '100%',
                                                        mt: 1,
                                                        border: '1px solid #E5E7EB',
                                                        borderRadius: '8px',
                                                        maxHeight: '300px',
                                                        overflowY: 'auto',
                                                        backgroundColor: '#FFFFFF',
                                                        zIndex: 1000,
                                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)'
                                                    }}>
                                                        {filteredPhoneNumbers.map((driver, index) => (
                                                            <Box
                                                                sx={{
                                                                    p: 2,
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    borderBottom: index < filteredPhoneNumbers.length - 1 ? '1px solid #E5E7EB' : 'none',
                                                                    cursor: 'pointer',
                                                                    '&:hover': { backgroundColor: '#F9FAFB' }
                                                                }}
                                                                key={index}
                                                                onClick={() => {
                                                                    // Fill customer details when a phone number is selected
                                                                    setDriverName(driver.driver_name || '');
                                                                    setDriverID(driver.driver_id || '');
                                                                    setDriverPhone(driver.phone_number || '');
                                                                    setDriverPhoneFilter(driver.phone_number || '');
                                                                    setShowPhoneResults(false);
                                                                }}
                                                            >
                                                                <Typography sx={{ fontWeight: 500 }}>{driver.phone_number}</Typography>
                                                                <Typography variant="body2" color="text.secondary">
                                                                    {driver.driver_name}
                                                                </Typography>
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                )}
                                            </Box>
                                        </Grid2>
                                        <Grid2 container spacing={2} sx={{ marginTop: '2%', display: 'flex' }}>

                                            <Grid2 item size={12}>
                                                <Label>Driver Name<span style={{ color: 'red' }}>*</span></Label>
                                                <TextField sx={{ marginTop: '1%' }}
                                                    placeholder="Driver Name" fullWidth variant="outlined" type="text"
                                                    value={driverName} disabled
                                                    onChange={(e) => { setDriverName(e.target.value); }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <PersonIcon sx={{ color: '#666' }} />
                                                            </InputAdornment>
                                                        ),
                                                        inputProps: { min: 0 },
                                                        style: { height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#fff', borderRadius: '8px' }
                                                    }}
                                                />
                                            </Grid2>
                                        </Grid2>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{ color: '#1A1E25', fontSize: '16px' }}>Fuel Amount</Label>
                                        <TextField sx={{ marginTop: '1%' }} placeholder="Fuel Amount" fullWidth variant="outlined" type="number"
                                            value={fuelAmount}
                                            onChange={(e) => {
                                                setFuelAmount(e.target.value);
                                                if(e.target.value == "" || e.target.value == 0) setFuelType(0);
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius: '12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{ color: '#1A1E25', fontSize: '16px' }}>Extra Charge</Label>
                                        <TextField sx={{ marginTop: '1%' }} placeholder="Extra Charge" fullWidth variant="outlined" type="number"
                                            value={extraCharge}
                                            onChange={(e) => {
                                                setExtraCharge(e.target.value);
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius: '12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{ color: '#1A1E25', fontSize: '16px' }}>Car Wash Amount</Label>
                                        <TextField sx={{ marginTop: '1%' }} placeholder="Car Wash Amount" fullWidth variant="outlined" type="number"
                                            value={carWashAmount}
                                            onChange={(e) => {
                                                setCarWashAmount(e.target.value);
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius: '12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{ color: '#1A1E25', fontSize: '16px' }}>Car Parking Amount</Label>
                                        <TextField sx={{ marginTop: '1%' }} placeholder="Car Parking Amount" fullWidth variant="outlined" type="number"
                                            value={carParkingAmount}
                                            onChange={(e) => {
                                                setCarParkingAmount(e.target.value);
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius: '12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label style={{ color: '#1A1E25', fontSize: '16px' }}>Select Vehicle<span style={{ color: 'red' }}>*</span></Label>

                                        <Select sx={{ marginTop: '2%' }}
                                            value={vehicleId}
                                            fullWidth
                                            onChange={(e) => {
                                                const selectedId = e.target.value;
                                                setVehicleId(selectedId);
                                            }} displayEmpty
                                            renderValue={(selected) => {
                                                const selectedVehicle = vehiclesData?.find(vehicle =>
                                                    vehicle.vehicle_make_id === selected || vehicle.id === selected);

                                                return (
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={blueCar} alt="Vehicle" style={{ marginRight: '8px', width: '30px', height: '30px' }} />
                                                        {selected && selectedVehicle ? selectedVehicle.vehicle_number : 'Select Vehicle'}
                                                    </Box>
                                                );
                                            }}
                                            style={{ height: '48px', borderRadius: '8px', backgroundColor: '#FFFFFF' }}>
                                            {/* <MenuItem value="">Select a vehicle</MenuItem> */}
                                            <MenuItem value="" disabled>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <img src={blueCar} alt="Vehicle" style={{ marginRight: '8px', width: '24px', height: '24px' }} />
                                                    Select Vehicle
                                                </Box>
                                            </MenuItem>
                                            {vehiclesData && vehiclesData.map((vehicle) => (
                                                <MenuItem key={vehicle.id}
                                                    value={vehicle.id}>
                                                    <img src={blueCar} alt="Vehicle" style={{ marginRight: '8px', width: '30px', height: '30px' }} />
                                                    {vehicle.vehicle_number}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} sx={{ marginTop: '2%' }}>
                                    <Label style={{ color: '#1A1E25', fontSize: '16px' }}>Fueling Date & Time<span style={{ color: 'red' }}>*</span></Label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer
                                            components={['DateTimePicker']}
                                            sx={{
                                                '& .MuiStack-root': {
                                                    padding: 0
                                                }
                                            }}
                                        >
                                            <DateTimePicker
                                                sx={{
                                                    width: '100%',
                                                    '& .MuiOutlinedInput-root': {
                                                        height: '48px',
                                                        borderRadius: '8px',
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '16px',
                                                        padding: '0px 14px',
                                                    }
                                                }}
                                                value={fuelingDateTime}
                                                onChange={(newValue) => { setFuelingDateTime(newValue); }}
                                                format={date_format_dd_mm_yy==1 ? "DD-MM-YYYY HH:mm" : "YYYY-MM-DD HH:mm"}
                                                ampm={false}
                                                slotProps={{
                                                    textField: {
                                                        fullWidth: true,
                                                        placeholder: 'Select date and time'
                                                    }
                                                }}
                                            />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Grid>

                                <Grid item xs={12} sm={12} sx={{ marginTop: '2%' }}>
                                    <Label style={{ color: '#1A1E25', fontSize: '16px' }}>Fuel Type</Label>
                                    <Select sx={{ marginTop: '2%' }}
                                        value={fuelType}
                                        fullWidth
                                        onChange={(e) => {
                                            const selectedId = e.target.value;
                                            setFuelType(selectedId);
                                        }}
                                        style={{ height: '48px', borderRadius: '8px', backgroundColor: '#FFFFFF' }}>
                                        <MenuItem value="0">Select Fuel Type</MenuItem>
                                        <MenuItem value="1">Petrol</MenuItem>
                                        <MenuItem value="2">Diesel</MenuItem>
                                    </Select>
                                </Grid>

                                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '8%' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        sx={{
                                            width: '140px', height: '50px', textTransform: 'none',
                                            fontSize: '16px', backgroundColor: '#0065FF', color: 'white'
                                        }}>
                                        {editable ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleClose}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Paper>

                        </div>
                    </Box>
                </div>
            )}

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'id'}
                                    direction={orderBy === 'id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('id')}
                                >
                                    ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'driver_id'}
                                    direction={orderBy === 'driver_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('driver_id')}
                                >
                                    Driver ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'driver_name'}
                                    direction={orderBy === 'driver_name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('driver_name')}
                                >
                                    Driver
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'vehicle_info'}
                                    direction={orderBy === 'vehicle_info' ? order : 'asc'}
                                    onClick={() => handleRequestSort('vehicle_info')}
                                >
                                    Vehicle Info
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'date'}
                                    direction={orderBy === 'date' ? order : 'asc'}
                                    onClick={() => handleRequestSort('date')}
                                >
                                    Date & Time
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'amount'}
                                    direction={orderBy === 'amount' ? order : 'asc'}
                                    onClick={() => handleRequestSort('amount')}
                                >
                                    Fuel Amount
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'extra_charge'}
                                    direction={orderBy === 'extra_charge' ? order : 'asc'}
                                    onClick={() => handleRequestSort('extra_charge')}
                                >
                                    Extra Charge
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'car_wash_amount'}
                                    direction={orderBy === 'car_wash_amount' ? order : 'asc'}
                                    onClick={() => handleRequestSort('car_wash_amount')}
                                >
                                    Car Wash Amount
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'car_parking_amount'}
                                    direction={orderBy === 'car_parking_amount' ? order : 'asc'}
                                    onClick={() => handleRequestSort('car_parking_amount')}
                                >
                                    Car Parking Amount
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    // active={orderBy === 'total_charges'}
                                    // direction={orderBy === 'total_charges' ? order : 'asc'}
                                    // onClick={() => handleRequestSort('total_charges')}
                                >
                                    Total Charges
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'fuel_type'}
                                    direction={orderBy === 'fuel_type' ? order : 'asc'}
                                    onClick={() => handleRequestSort('fuel_type')}
                                >
                                    Fuel Type
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={10} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {(rowsPerPage > 0
                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : rows
                        ).map((row) => (
                            <TableRow key={row.helper_id}>
                                <TableCell>{row.id}</TableCell>
                                <TableCell>{row.driver_id}</TableCell>
                                <TableCell>
                                    <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                        <Grid2>
                                            <Avatar
                                                sx={{ borderColor: "#0065FF", border: 1 }}
                                                alt={row.driver_name}
                                                src={row.driver_image}
                                            ></Avatar>
                                        </Grid2>
                                        <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                            <Grid2>
                                                <Typography>{row.driver_name}</Typography>
                                            </Grid2>
                                            <Grid2>
                                                <Typography
                                                    sx={{ color: "#83888E", fontSize: "12px" }}
                                                >
                                                    {row.phone_number}
                                                </Typography>
                                            </Grid2>
                                        </Grid2>
                                    </Grid2>
                                </TableCell>
                                <TableCell>
                                    <Grid2 sx={{ width: "auto", minWidth: "180px", display: "flex", alignItems: "center" }}>
                                        <img src={blueCar} alt="blueCar" height="40px" width="40px" />
                                        <Typography>{row.vehicle_number}</Typography>
                                    </Grid2>
                                </TableCell>
                                <TableCell>
                                    {row.date ? 
                                        (() => {
                                        const pickupDate = new Date(row.date);
                                        // Add the offset minutes to the date
                                        pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                                        return pickupDate.toLocaleString('en-GB', {
                                            day: '2-digit', 
                                            month: '2-digit', 
                                            year: 'numeric', 
                                            hour: '2-digit', 
                                            minute: '2-digit', 
                                            hour12: timeZoneFormat == '12' ? true : false,
                                            timeZone: 'UTC'
                                        }).replace(',', ' |');
                                        })() 
                                        : '--'
                                    }
                                </TableCell>
                                <TableCell>{row.amount}</TableCell>
                                <TableCell>{row.extra_charge}</TableCell>
                                <TableCell>{row.car_wash_amount}</TableCell>
                                <TableCell>{row.car_parking_amount}</TableCell>
                                <TableCell>{row.amount + row.extra_charge + row.car_wash_amount + row.car_parking_amount}</TableCell>
                                <TableCell>{row.fuel_type == 1 ? 'Petrol' : row.fuel_type == 2 ? 'Diesel' : '--'}</TableCell>
                                <TableCell>
                                    <Button
                                        variant="contained"
                                        onClick={() => handleOpenEditModal(row)}
                                        sx={{
                                            backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                            borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "90px",
                                            '&:hover': { backgroundColor: '#0DBA78', color: 'white' },
                                            '&:active': { backgroundColor: '#0DBA78', color: 'white' }
                                        }}>

                                        <Typography sx={{ marginRight: '6%' }}>Edit</Typography>
                                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor" />
                                            <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor" />
                                        </svg>
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                        <button
                            onClick={() => handleChangePage(null, page - 1)}
                            disabled={page === 0}
                            className="pagination-arrow"
                        >
                            <img src={prevIcon} alt="Previous" />
                        </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>
            
            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
            
        </div>
    );
};

export default FuelConsumption;